import { createSelector } from 'reselect';

import { AppSettingsSlice, name } from './reducer';

const getAppSettingsState = (state: AppSettingsSlice) => state[name];

export const systemCacheRequestingSelector = createSelector(getAppSettingsState, state => state.requestingSystemCache);
export const internalSettingsSelector = createSelector(getAppSettingsState, state => ({
    lobsterUrl: state.lobsterXmlOrderUrl,
    defaultCfpTextContract: state.defaultCfpTextContract,
    defaultCfpTextBonus: state.defaultCfpTextBonus,
    statusScale: state.statusScale,
    isRequesting: state.requestingLobsterXml,
}));

export const notificationsSelector = createSelector(getAppSettingsState, state => state.notifications);
